import React from 'react';
import { getLabel } from "../functions/lang";

// StatTableHead: réutilisable pour rendre le thead des tableaux de stats
// Props: configsColumn (array), language (string)
const StatTableHead = ({ configsColumn = [], language, firstColumnHeader = '', showTotal = false, totalColumnLabel = 'TOTAL' }) => {
    return (
        <thead>
            <tr>
                <th className="fixed-td">{firstColumnHeader}</th>
                {configsColumn.length > 0
                    ? configsColumn.map((item, index) => (
                        <th className="scrollable-td fixed-hd" key={index}>
                            {getLabel(item, language)}
                        </th>
                    ))
                    : <th className="fixed-td fixed-hd left-top-td"></th>}
            </tr>
            <tr>
                <th className="fixed-td"></th>
                {configsColumn.length > 0
                    ? configsColumn.map((item, index) => (
                        <th className="scrollable-td fixed-hd" key={index}>
                            {getLabel({
                                label_fr: item.unitlabel_fr,
                                label_en: item.unitlabel_en,
                                label_pr: item.unitlabel_pr,
                                label_sw: item.unitlabel_sw
                            }, language)}
                        </th>
                    ))
                    : <th className="fixed-td fixed-hd left-top-td"></th>}
                {showTotal ? <th>{totalColumnLabel}</th> : null}
            </tr>
        </thead>
    );
};

export default StatTableHead;
